export default class BaseService {
  getHost() {
    return process.env.API_HOST;
  }
}
